import { render, staticRenderFns } from "./ParcelStatus.vue?vue&type=template&id=3a429144&"
import script from "./ParcelStatus.vue?vue&type=script&lang=js&"
export * from "./ParcelStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports